var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPendingOrderIcon = function SvgPendingOrderIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0A821",
    d: "M14.723 7.987c-2.91 0-5.278 2.367-5.278 5.277s2.368 5.278 5.278 5.278c2.91 0 5.277-2.368 5.277-5.278 0-2.91-2.367-5.277-5.277-5.277zm2.22 5.928h-2.261c-.337 0-.61-.273-.61-.61v-2.262c0-.336.273-.61.61-.61.337 0 .61.274.61.61v1.652h1.652c.336 0 .61.273.61.61 0 .337-.273.61-.61.61z",
    transform: "translate(6 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D7278",
    d: "M6.8 4.769l1.237-.518c.15-.063.32-.063.471 0l1.236.518V.019H6.801v4.75z",
    transform: "translate(6 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#604325",
    d: "M14.723 6.767c.632 0 1.244.091 1.822.26V1.519c0-.826-.672-1.498-1.499-1.498h-4.082v5.666c0 .204-.102.394-.272.508-.102.067-.22.102-.338.102-.08 0-.16-.016-.236-.048l-1.846-.773-1.846.773c-.188.08-.403.059-.573-.054-.17-.114-.272-.304-.272-.508V.02H1.499C.672.02 0 .692 0 1.518v13.548c0 .826.672 1.499 1.499 1.499h7.629c-.573-.968-.903-2.097-.903-3.3 0-3.583 2.915-6.498 6.498-6.498z",
    transform: "translate(6 7)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPendingOrderIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pending_order_icon.9722753a.svg";
export { ForwardRef as ReactComponent };